<template>
  <v-main class="public-layout">
    <router-view></router-view>
  </v-main>
</template>

<script>
export default {}
</script>

<style scoped>
.public-layout {
  background: #f5f7fa;
  min-height: 100vh;
}
</style>
